// Need to use the React-specific entry point to import createApi
import {apiSlice} from './apiSlice';

export const bookmarkApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // getBookmarks: builder.query({
    //   query: () => 'bookmark/',
    // }),
    createBookmark: builder.mutation({
      query: body => ({
        url: 'bookmark/',
        method: 'POST',
        body
      }),
      invalidatesTags: ['Bookmark', 'Session', 'Patient'],
    }),
    removeBookmark: builder.mutation({
      query: ({id}) => ({
        url: `bookmark/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Bookmark', 'Session', 'Patient'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  // useBookmarksQuery,
  useCreateBookmarkMutation,
  useRemoveBookmarkMutation,
} = bookmarkApi;
